<template>
  <div class="root-container">
    <div class="table-container">
      <!-- 搜索栏（固定） -->
      <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
        <!-- 电脑端 -->
        <div v-if="isDesktop" class="desktop-search-wrapper">
          <div class="search-row">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索下载资料标题"
              prefix-icon="el-icon-search"
              class="search-input"
              @keyup.enter="handleSearch"
            >
              <template slot="append">
                <el-button @click="handleSearch">搜索</el-button>
              </template>
            </el-input>

            <div class="button-group">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd" class="add-button">
                添加
              </el-button>
              <el-button type="primary" size="small" icon="el-icon-filter" @click="toggleFilter" class="filter-button">
                {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
              </el-button>
            </div>
          </div>

          <!-- 电脑端筛选面板 -->
          <div v-if="isFilterOpen" class="filter-panel">
            <div class="filter-row">
              <div class="filter-item">
                <label>语言：</label>
                <el-select v-model="filterForm.language" placeholder="选择语言" style="width: 150px;">
                  <el-option value="" label="全部" />
                  <el-option v-for="lang in languageList" :key="lang.code" :label="lang.name" :value="lang.code" />
                </el-select>
              </div>
              <div class="filter-item">
                <label>首页展示：</label>
                <el-select v-model="filterForm.is_home" placeholder="全部" style="width: 150px;">
                  <el-option value="" label="全部" />
                  <el-option :value="1" label="已展示" />
                  <el-option :value="0" label="未展示" />
                </el-select>
              </div>
            </div>
            <div class="filter-actions">
              <div class="applied-filters">
                <span v-if="!filterForm.language && (filterForm.is_home === '' || filterForm.is_home === undefined)" class="filter-tag filter-tag-empty">
                  当前无筛选条件
                </span>
                <span v-if="filterForm.language" class="filter-tag">
                  语言：{{ getLanguageName(filterForm.language) }}
                  <i class="el-icon-close" style="margin-left:5px;cursor:pointer;" @click="filterForm.language = ''"></i>
                </span>
                <span v-if="filterForm.is_home !== '' && filterForm.is_home !== undefined" class="filter-tag">
                  {{ filterForm.is_home === 1 ? '已展示' : '未展示' }}
                  <i class="el-icon-close" style="margin-left:5px;cursor:pointer;" @click="filterForm.is_home = ''"></i>
                </span>
              </div>
              <div class="filter-buttons">
                <el-button size="small" @click="resetFilter">重置筛选</el-button>
                <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 -->
        <div v-else class="mobile-search-wrapper">
          <div class="mobile-add-button">
            <van-button type="primary" size="small" block icon="plus" @click="handleAdd" style="margin-top: 10px;">
              添加
            </van-button>
          </div>

          <div v-if="isFilterOpen" class="mobile-filter-panel">
            <div class="mobile-applied-filters">
              <div v-if="!filterForm.language && (filterForm.is_home === '' || filterForm.is_home === undefined)" class="applied-tags">
                <span class="mobile-filter-tag empty">当前无筛选条件</span>
              </div>
            </div>
            <div class="mobile-filter-actions">
              <van-button type="default" size="small" @click="resetFilter">重置</van-button>
              <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
            </div>
          </div>

          <div class="mobile-filter-toggle" @click="toggleFilter">
            <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" />
            <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
          </div>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content-container">
        <!-- 电脑端表格 -->
        <div class="table-wrapper" v-if="isDesktop">
          <el-table :data="downloadList" style="width: 100%" tooltip-effect="dark" empty-text="暂无数据"
            class="desktop-table" :height="tableHeight">
            <el-table-column label="标题" prop="title" align="left" width="250px" fixed>
              <template slot-scope="scope">
                <div>{{ scope.row.title }}</div>
                <div v-if="scope.row.sub_title" style="font-size:12px;color:#909399;margin-top:4px;">{{ scope.row.sub_title }}</div>
              </template>
            </el-table-column>
            <el-table-column label="下载链接" align="left" width="250px">
              <template slot-scope="scope">
                <el-link v-if="scope.row.link" :href="scope.row.link" target="_blank" type="primary" :underline="false" style="max-width:220px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;">
                  {{ scope.row.link }}
                </el-link>
                <span v-else style="color:#909399;">--</span>
              </template>
            </el-table-column>
            <el-table-column label="语言" align="left" width="120px">
              <template slot-scope="scope">
                {{ scope.row.language_name || '--' }}({{ scope.row.language_code }})
              </template>
            </el-table-column>
            <el-table-column label="首页展示" align="center" width="100px">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.is_home === 1"
                  active-color="#409EFF"
                  inactive-color="#dcdfe6"
                  @change="handleHomeChange(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at" align="left" width="180px">
            </el-table-column>
            <el-table-column label="操作" align="right" fixed="right" width="155px">
              <template slot-scope="scope">
                <div class="table-actions">
                  <el-link @click="handleEdit(scope.row)">
                    <i class="el-icon-edit" style="font-size:16px;"></i>编辑
                  </el-link>
                  <el-dropdown @command="command($event, scope.row)">
                    <span class="el-dropdown-link">
                      更多操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="remove">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片 -->
        <div v-else class="mobile-cards">
          <div v-if="downloadList.length === 0" class="mobile-empty">暂无数据</div>
          <div v-for="item in downloadList" :key="item.id" class="mobile-card">
            <div class="card-header">
              <div class="card-title">
                <h3>{{ item.title }}</h3>
                <span v-if="item.sub_title" style="font-size:12px;color:#909399;">{{ item.sub_title }}</span>
              </div>
              <van-switch
                :value="item.is_home === 1"
                size="22px"
                @change="handleHomeChange(item)"
              />
            </div>
            <div class="card-content">
              <p><strong>语言：</strong>{{ item.language_name || '--' }}({{ item.language_code }})</p>
              <p v-if="item.link"><strong>链接：</strong><a :href="item.link" target="_blank" style="color:#409EFF;word-break:break-all;">{{ item.link }}</a></p>
              <p><strong>时间：</strong>{{ item.created_at }}</p>
            </div>
            <div class="card-actions">
              <van-button type="primary" size="small" @click="handleEdit(item)">编辑</van-button>
              <van-button type="danger" size="small" @click="handleDelete(item.id)">删除</van-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div v-if="isDesktop && total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :page-size.sync="params.page_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加/编辑对话框 -->
    <template v-if="isDesktop">
      <el-drawer :title="dialogTitle" :visible.sync="dialogVisible" size="70%" :before-close="handleClose">
        <add-download :download="editingItem" @save="handleSave" @cancel="handleClosePopup" />
      </el-drawer>
    </template>
    <template v-else>
      <van-popup v-model="dialogVisible" position="bottom" :round="true" :style="{ height: '80%' }" :close-on-click-overlay="false">
        <div class="popup-header">
          <h3>{{ dialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <add-download :download="editingItem" @save="handleSave" @cancel="handleClosePopup" />
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import AddDownload from './components/add-download.vue'
import { getDownloads, deleteDownload, setDownloadHome } from '@/api/website'
import { getLanguage } from '@/api/public'
import { Dialog } from 'vant'

export default {
  name: 'DownloadPage',
  components: {
    AddDownload
  },
  data() {
    return {
      isDesktop: true,
      searchKeyword: '',
      // 筛选
      isFilterOpen: false,
      filterForm: {
        language: '',
        is_home: ''
      },
      languageList: [],
      // 列表数据
      downloadList: [],
      params: {
        page: 1,
        page_count: 10
      },
      total: 0,
      // 弹窗
      dialogVisible: false,
      dialogTitle: '',
      editingItem: null
    }
  },
  computed: {
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 200 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 120 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    this.getLanguageList()
    this.getTableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    getLanguageName(code) {
      var lang = this.languageList.find(function(l) { return l.code === code })
      return lang ? lang.name : code
    },
    async getLanguageList() {
      try {
        const res = await getLanguage()
        this.languageList = res.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    getTableData() {
      getDownloads(this.params).then(res => {
        const data = res.data || {}
        this.downloadList = data.data ? Object.values(data.data) : []
        this.total = data.total || 0
      })
    },
    handleSizeChange(val) {
      this.params.page_count = val
      this.params.page = 1
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getTableData()
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    applyFilter() {
      this.params.page = 1
      this.getTableData()
    },
    resetFilter() {
      this.filterForm = { language: '', is_home: '' }
      this.params.page = 1
      this.getTableData()
    },
    handleAdd() {
      this.dialogTitle = '添加下载资料'
      this.editingItem = null
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.dialogTitle = '编辑下载资料'
      this.editingItem = { ...item }
      this.dialogVisible = true
    },
    command(cmd, row) {
      if (cmd === 'remove') {
        this.handleDelete(row.id)
      }
    },
    handleHomeChange(row) {
      const newVal = row.is_home === 1 ? 0 : 1
      setDownloadHome(row.id, { is_home: newVal }).then(res => {
        if (res.code === 200) {
          row.is_home = newVal
          this.$message.success(newVal === 1 ? '已设为首页展示' : '已取消首页展示')
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除该下载资料吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDownload(id).then(res => {
          if (res.code === 200) {
            this.getTableData()
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        })
      }).catch(() => {})
    },
    handleSave() {
      this.dialogVisible = false
      this.getTableData()
      this.$message.success('保存成功')
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.dialogVisible = false
      }).catch(function() {})
    }
  }
}
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

.filter-button {
  white-space: nowrap;
}

.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

.filter-buttons {
  display: flex;
  gap: 10px;
}

/* 手机端筛选 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

.mobile-search-wrapper {
  width: 100%;
}

.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域 */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions {
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-title {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  margin-right: 10px;
}

.card-title h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 弹窗 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--background);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--background);
}

/* 分页 */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式 */
@media (max-width: 768px) {
  .search-container {
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }

  .search-container .search-input {
    display: none;
  }

  .desktop-table {
    display: none;
  }

  .mobile-cards {
    display: flex;
  }

  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-input {
    max-width: 100%;
  }

  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .filter-item {
    width: 100%;
  }

  .filter-item .el-select {
    width: 100% !important;
  }

  .content-container {
    padding: 10px 0;
  }

  .pagination-container {
    text-align: center;
    padding: 15px;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }

  .desktop-table {
    display: block;
  }

  .mobile-cards {
    display: none;
  }
}
</style>
